import { useQuery } from '@tanstack/react-query';
import { getTransactionHistory, TransactionHistoryResponse } from '@/api/wallet';
import { useAuth } from '@/contexts/AuthContext';

export const useTransactionHistory = () => {
  const { isAuthenticated } = useAuth();

  return useQuery<TransactionHistoryResponse, Error>({
    queryKey: ['transactionHistory'],
    queryFn: getTransactionHistory,
    staleTime: 1000 * 300, // 5分間はキャッシュを使用
    refetchOnWindowFocus: true, // ウィンドウフォーカス時に再取得
    enabled: isAuthenticated, // 認証済みの場合のみ実行
  });
};
